import {createContext} from 'react';

const storeContext = createContext({
    appState: undefined,
    dispatch: undefined
});

export default storeContext;